import { type FC, useEffect } from "react";
import { useLocation } from "react-router";

import { useTrackActivity } from "src/activity/useTrackActivity";

/** Emits `page.viewed` on every client-side navigation. Rendered once inside the signed-in shell. */
export const RouteActivity: FC = () => {
	const { pathname } = useLocation();
	const track = useTrackActivity();

	useEffect(() => {
		// Defer one tick so the new page has set document.title (and its scope) first.
		const handle = setTimeout(() => track({ type: "page.viewed", data: {} }), 0);
		return () => clearTimeout(handle);
	}, [pathname, track]);

	return null;
};
